import * as React from 'react'
import { Columns, Column } from 'react-flex-columns'
import Centered from 'shared/ui/Centered'
import { Pagination, PaginationList, PaginationItem, PaginationLink } from 'shared/ui/Pagination'
import { Link } from '../ui/Link'
import BlogListings from '../ui/blog/BlogListings'
import BlogIndexHero from '../ui/blog/BlogIndexHero'
import Heading from 'shared/ui/Heading'

export default function BlogIndexPage({ pageContext }) {
  const { featured, posts, totalPages, currentPage } = pageContext

  return (
    <div className="blog-index-page">
      <BlogIndexHero post={featured} />
      <Centered>
        <section className="spacing">
          <Columns gutters split middle>
            <Column>
              <Heading as="h1" size={2}>
                Blog Posts
              </Heading>
            </Column>
            <Column>
              <Pagination
                pages={totalPages}
                currentPage={currentPage}
                url={(page) => (page === 1 ? '/blog/' : `/blog/${page}`)}
              >
                <PaginationList>
                  {Array.from(new Array(totalPages)).map((_, index) => (
                    <PaginationItem key={index}>
                      <PaginationLink as={Link} page={index + 1} />
                    </PaginationItem>
                  ))}
                </PaginationList>
              </Pagination>
            </Column>
          </Columns>
          <hr />
          <BlogListings posts={posts} />
          <div>
            <Pagination
              pages={totalPages}
              currentPage={currentPage}
              url={(page) => (page === 1 ? '/blog/' : `/blog/${page}`)}
            >
              <PaginationList>
                {Array.from(new Array(totalPages)).map((_, index) => (
                  <PaginationItem key={index}>
                    <PaginationLink as={Link} page={index + 1} />
                  </PaginationItem>
                ))}
              </PaginationList>
            </Pagination>
          </div>
        </section>
      </Centered>
    </div>
  )
}
